import { Component, OnInit } from '@angular/core';
import { UserHelper } from 'src/app/core/helpers/user.helper';
import { IPaymentReceipt } from 'src/app/core/models/payment.model';
import { PaymentService } from '../payment.service';

@Component({
  selector: 'air-payment-total',
  templateUrl: './payment-total.component.html'
})
export class PaymentTotalComponent implements OnInit {
  receipt?: IPaymentReceipt;

  get remainingBalance(): number {
    return (this.userHelper.currentUser?.balance ?? 0) - (this.paymentService.receipt?.total?.points ?? 0);
  }

  constructor(
    private paymentService: PaymentService,
    private userHelper: UserHelper
  ) {}

  ngOnInit(): void {
    this.receipt = this.paymentService.receipt;
  }
}
